import {
    GET_JOB_OFFER_ALERTS_SUCCESS,
    DELETE_JOB_OFFER_ALERT_SUCCESS,
    TOGGLE_JOB_OFFER_ALERT_SUCCESS,
    CREATE_JOB_OFFER_ALERT_SUCCESS
} from '../action-types'

const INIT_STATE = {
    alerts: []
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_JOB_OFFER_ALERTS_SUCCESS:
            return {
                ...state,
                alerts: action.data
            }
        case DELETE_JOB_OFFER_ALERT_SUCCESS:
            return {
                ...state,
                alerts: state.alerts.filter(alert => alert.id !== action.alertId)
            }
        case TOGGLE_JOB_OFFER_ALERT_SUCCESS:
            return {
                ...state,
                alerts: state.alerts.map(alert => 
                    alert.id === action.alertId 
                        ? { ...alert, is_active: !alert.is_active }
                        : alert
                )
            }
        case CREATE_JOB_OFFER_ALERT_SUCCESS:
            return {
                ...state,
                alerts: action.data
            }
        default:
            return state
    }
}
